import type { FC } from 'react';
import type { AirportExtended } from '@/types/domain/core';
import { Chip, DataView, Flex, Section } from '@ui';
import { groupPositions } from '@/components/AirportDetailed/utils/groupPositions';
import styles from './CodesPositions.module.css';

type Props = {
    airport: AirportExtended;
};

type Subcomponents = {
    Skeleton: FC;
};

const CodesPositions: FC<Props> & Subcomponents = ({ airport }) => (
    <Flex justify="space-between">
        <Section variant="outlined" noPadding>
            <Flex gap={32} className={styles.codesContainer}>
                <DataView title="ICAO" value={airport.icao} />
                {airport.iata && <DataView title="IATA" value={airport.iata} />}
            </Flex>
        </Section>
        <Section variant="outlined">
            <Flex gap={32}>
                {groupPositions(airport.positions).map(({ id, name, active }) => (
                    <Chip key={id} variant={active ? 'active' : 'default'}>
                        {name}
                    </Chip>
                ))}
            </Flex>
        </Section>
    </Flex>
);

CodesPositions.Skeleton = () => (
    <Flex justify="space-between">
        <Section variant="outlined" noPadding>
            <Flex gap={32} style={{ height: '100%' }} className={styles.codesContainer}>
                <DataView.Skeleton />
                <DataView.Skeleton />
            </Flex>
        </Section>
        <Section variant="outlined">
            <Flex gap={32}>
                {Array.from({ length: 4 }).map((_, index) => (
                    <Chip.Skeleton key={index} />
                ))}
            </Flex>
        </Section>
    </Flex>
);

export { CodesPositions };
